"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachBuildFlow = exports.BlueprintDataSource = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var SelectSource_1 = __importDefault(require("./Steps/SelectSource"));
var ImportFromSource_1 = __importDefault(require("./Steps/ImportFromSource"));
var BuildProjects_1 = __importDefault(require("./Steps/BuildProjects"));
var CsvImport_1 = __importDefault(require("./Sources/CsvImport"));
var PipedriveImportController_1 = __importDefault(require("./Sources/PipedriveImportController"));
var ExploreProjects_1 = __importDefault(require("./Steps/ExploreProjects"));
var BlueprintDataSource;
(function (BlueprintDataSource) {
    BlueprintDataSource["Csv"] = "spreadsheet csv";
    BlueprintDataSource["Pipedrive"] = "pipedrive";
})(BlueprintDataSource || (exports.BlueprintDataSource = BlueprintDataSource = {}));
var BuildFlow = (function (_super) {
    __extends(BuildFlow, _super);
    function BuildFlow(props) {
        var _this = _super.call(this, props) || this;
        _this.currentStep = 0;
        _this.currentlyProcessing = false;
        _this.renderImportFromSource = function () {
            return (react_1.default.createElement(ImportFromSource_1.default, { goBackToThisStep: _this.goBackToImportFromSource, variables: _this.importedVariables && _this.importedVariables[0], finished: _this.currentStep > 1, importError: _this.importError }, _this.renderImportSource()));
        };
        _this.renderBuildProjects = function () {
            return (react_1.default.createElement(BuildProjects_1.default, { goBackToThisStep: _this.goBackToBuildProjects, data: _this.importedVariables, buildProjects: _this.buildProjects, finished: _this.currentStep > 2, currentlyProcessing: _this.currentlyProcessing, buildError: _this.buildError }));
        };
        _this.renderExploreProjects = function () {
            var _a = _this.props, getOutputFile = _a.getOutputFile, showChildProjects = _a.showChildProjects;
            var wrappedGetOutputFile = function () { return getOutputFile(_this.builtProjects); };
            return react_1.default.createElement(ExploreProjects_1.default, { getOutputFile: wrappedGetOutputFile, showChildren: showChildProjects });
        };
        _this.selectSource = function (source) {
            _this.selectedSource = source;
            _this.currentStep++;
        };
        _this.goBackToSelectSource = function () {
            _this.goBackToImportFromSource();
            _this.selectedSource = undefined;
            _this.currentStep = 0;
        };
        _this.goBackToImportFromSource = function () {
            _this.goBackToBuildProjects();
            _this.importedVariables = undefined;
            _this.importError = undefined;
            _this.currentStep = 1;
        };
        _this.renderImportSource = function () {
            switch (_this.selectedSource.internalName) {
                case "csv":
                    return react_1.default.createElement(CsvImport_1.default, { onImported: _this.onImported });
                case "pipedrive":
                    return (react_1.default.createElement(PipedriveImportController_1.default, { onImported: _this.onImported, integrationApiService: _this.props.integrationApiService }));
            }
            return null;
        };
        _this.onImported = function (source, result, errorMessage) {
            if (!!result) {
                _this.props.telemetry.trackOnly("Project Blueprint Data Imported", {
                    blueprint_data_import_source: source,
                });
            }
            _this.importedVariables = result || undefined;
            _this.importError = errorMessage;
            _this.currentStep++;
        };
        _this.goBackToBuildProjects = function () {
            _this.currentStep = 2;
        };
        _this.buildProjects = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.currentlyProcessing = true;
                        _a = this;
                        return [4, this.props.runBuild(this.importedVariables)];
                    case 1:
                        _a.builtProjects = _b.sent();
                        this.currentlyProcessing = false;
                        this.currentStep++;
                        return [2];
                }
            });
        }); };
        _this.sources = getSources(props.integrationSettingsService);
        return _this;
    }
    BuildFlow.prototype.render = function () {
        return (react_1.default.createElement("section", { className: "blueprint-build-flow" },
            react_1.default.createElement(SelectSource_1.default, { sources: this.sources, selectSource: this.selectSource, goBackToThisStep: this.goBackToSelectSource, finished: this.currentStep > 0, selected: this.selectedSource && this.selectedSource.internalName }),
            this.currentStep > 0 && this.renderImportFromSource(),
            this.currentStep > 1 && this.renderBuildProjects(),
            this.currentStep > 2 && this.renderExploreProjects()));
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], BuildFlow.prototype, "currentStep", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], BuildFlow.prototype, "selectedSource", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], BuildFlow.prototype, "importedVariables", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], BuildFlow.prototype, "importError", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], BuildFlow.prototype, "currentlyProcessing", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], BuildFlow.prototype, "buildError", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], BuildFlow.prototype, "builtProjects", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BuildFlow.prototype, "selectSource", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BuildFlow.prototype, "goBackToSelectSource", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BuildFlow.prototype, "goBackToImportFromSource", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BuildFlow.prototype, "onImported", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BuildFlow.prototype, "goBackToBuildProjects", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BuildFlow.prototype, "buildProjects", void 0);
    BuildFlow = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], BuildFlow);
    return BuildFlow;
}(react_1.default.Component));
exports.default = BuildFlow;
var getSources = function (service) {
    var sources = [
        {
            internalName: "csv",
            title: "Spreadsheet CSV",
            description: "Import data from a CSV (comma-separated values) file.",
            cssClass: "csv",
            cssIcon: "grid2",
        },
    ];
    if (service.isEnabled("pipedrive")) {
        sources.push({
            internalName: "pipedrive",
            title: "Pipedrive",
            description: "Import deals from Pipedrive",
            cssClass: "pipedrive",
            cssIcon: "save",
        });
    }
    return sources;
};
var attachBuildFlow = function (integrationService, integrationApiService, runBuild, showChildProjects, getOutputFile, mountReactComponent, telemetry) {
    return mountReactComponent(react_1.default.createElement(BuildFlow, { integrationSettingsService: integrationService, integrationApiService: integrationApiService, runBuild: runBuild, showChildProjects: showChildProjects, getOutputFile: getOutputFile, telemetry: telemetry }));
};
exports.attachBuildFlow = attachBuildFlow;
